// #region Imports
import { defineComponent, reactive } from "vue";
import modalMixin from "../../../mixins/modal.mixin";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-server-page-modal',
    mixins: [modalMixin],
    props: {
        title: {
            type: String,
            required: false,
            default: ''
        },
        templateUrl: {
            type: String,
            required: false,
            default: ''
        },
        templateHtml: {
            type: String,
            required: false,
            default: ''
        },
        dataObject: {
            type: Object,
            required: false,
            default() {
                return reactive({});
            }
        }
    },
    data: () => ({
        contentHtml: '',
        isLoading: true,
        _title: '',
    }),
    created() {
        //Internal
        this._title = this.title;
        //Data
        this.loadData();
    },
    beforeMount() {
        this.$host.eventBus.on('refresh', this.loadData);
    },
    beforeUnmount() {
        this.$host.eventBus.off('refresh', this.loadData);
    },
    watch: {
        'title': function (value) {
            this._title = value;
        }
    },
    methods: {
        async loadData() {
            // #region Html
            if (utils.isNullOrEmpty(this.templateUrl) && !utils.isNullOrEmpty(this.templateHtml)) {
                this.contentHtml = this.templateHtml;
                this.isLoading = false;
                return;
            }
            // #endregion
            // #region Check
            if (utils.isNullOrEmpty(this.templateUrl)) {
                this.isLoading = false;
                return;
            }
            // #endregion
            // #region Start
            this.isLoading = true;
            // #endregion
            // #region Load
            host.views.get(eval(this.templateUrl))
                .then(e => {
                if (e.data) {
                    //Content
                    if (e.data.body) {
                        this.contentHtml = e.data.body;
                    }
                    else if (e.data) {
                        this.contentHtml = e.data.body;
                    }
                    if (e.data.title) {
                        this._title = e.data.title;
                    }
                }
                this.isLoading = false;
            })
                .catch(e => {
                this.contentHtml = '<pre>' + utils.getAxiosErrorMessage(e) + '</pre>';
                this.isLoading = false;
            });
            // #endregion
        }
    }
});
// #endregion
